import "../../index34.css";
import { jsxs as l, jsx as t } from "react/jsx-runtime";
import { _ as n } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
const u = "_input-label_yjedu_1", c = "_disabled_yjedu_7", o = "_required_yjedu_11", e = {
  inputLabel: u,
  disabled: c,
  required: o
};
function f(r) {
  const {
    children: i,
    className: d,
    disabled: s,
    required: a
  } = r;
  return i ? /* @__PURE__ */ l(
    "div",
    {
      className: n(
        e.inputLabel,
        s && e.disabled,
        d
      ),
      children: [
        i,
        a && /* @__PURE__ */ t("span", { "aria-hidden": !0, className: e.required, children: "*" })
      ]
    }
  ) : null;
}
export {
  f as default
};
